var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEnvelopeStroke = function SvgIconEnvelopeStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.64,
    d: "M23 4v12.25c0 2.07-1.68 3.75-3.75 3.75H4.75C2.68 20 1 18.32 1 16.25V4zM2.7 17.3a1 1 0 0 0 1 1h16.6c.552 0 1-.448.999-1V6.253L14.65 12.9a3.75 3.75 0 0 1-5.303 0L2.699 6.252zM4.551 5.7l6.741 6.741a1 1 0 0 0 1.414 0l6.741-6.74z"
  })));
};
export default SvgIconEnvelopeStroke;